import { v4 as uuidv4 } from 'uuid';

let mqttSubscriptions = {};
const MixinMqttClient = {
  data() {
    return {
      mqttClient: null,
      mqttReconnectInterval: null
    };
  },
  created() {
    this.connectMQTT();
  },
  // beforeDestroy() {
  //   this.disconnectMQTT();
  // },
  computed: {
    disabledMQTT() {
      return this.$route.path.startsWith("/login") || this.$route.path.startsWith("/device-player") || this.$route.path.startsWith("/reset-passwd");
    },
    mqttUser() {
      return this.$store.getters.currentUser;
    },
    mqttUserListenerTopicName() {
      return this.mqttUser && this.mqttUser.listenerNoticeTopicName;
    },
    mqttToken() {
      return this.mqttUser && this.mqttUser.mqttToken;
    },
    mqttClientId() {
      let mqttClientId = localStorage.getItem("mqttClientId");
      if (!mqttClientId) {
        mqttClientId = `mqttjs_${uuidv4().replace(/-/g, '')}`;
        localStorage.setItem("mqttClientId", mqttClientId);
      }
      return mqttClientId
    }
  },
  watch: {
    mqttToken(newVal, oldVal) {
      this.connectMQTT();
    },
    disabledMQTT(newVal, oldVal) {
      if (newVal) {
        this.disconnectMQTT();
      } else {
        this.connectMQTT();
      }
    }
  },
  methods: {
    connectMQTT() {
      if (this.disabledMQTT) {
        return;
      }
      // 如果已经存在客户端，直接使用
      if (this.$root.mqttClient) {
        this.mqttClient = this.$root.mqttClient;
        return;
      }
      if (!this.mqttToken) {
        console.error("MQTT token is required");
        return;
      }
      const [username, password] = atob(this.mqttToken).split(":");

      // 创建新连接
      const client = mqtt.connect(process.env.VUE_APP_MQTT_URL, {
        clientId: this.mqttClientId,
        clean: false, // 会话持久性；true：临时客户端或不需要持久化的场景，false：需要断线重连后保持订阅状态的场景
        keepAlive: 60, // 心跳间隔时间（秒）
        connectTimeout: 30 * 1000, // 连接超时时间（毫秒）
        reconnectPeriod: 1000, // 重连间隔时间（毫秒）
        username,
        password
      });

      this.mqttClient = client;
      this.$root.mqttClient = client; // 挂载到根实例实现单例

      client.on("connect", () => {
        console.log("MQTT Connected");
        // 重新订阅之前订阅的主题
        Object.keys(mqttSubscriptions).forEach(topic => {
          client.subscribe(topic, err => {
            if (!err) console.log(`Subscribed to ${topic}`);
          });
        });
      });

      client.on("message", (topic, message) => {
        const callback = mqttSubscriptions[topic];
        console.log([`收到【${topic}】消息`, message.toString()]);
        if (callback) {
          callback(message.toString());
        }
      });

      client.on("error", err => {
        console.error("MQTT Error:", err);
      });

      client.on("close", () => {
        console.log("MQTT Disconnected");
      });
    },

    disconnectMQTT() {
      if (this.mqttClient) {
        this.mqttClient.end();
        this.mqttClient = null;
        this.$root.mqttClient = null;
      }
    },

    subscribeMQTT(topic, callback) {
      console.log("MQTT subscribeMQTT", topic);
      mqttSubscriptions[topic] = callback;
      if (!this.mqttClient) {
        console.error("MQTT client not initialized");
        return;
      }
      this.mqttClient.subscribe(topic, err => {
        if (!err) console.log(`Subscribed to ${topic}`);
      });
    },

    unsubscribeMQTT(topic) {
      if (!this.mqttClient) return;

      this.mqttClient.unsubscribe(topic, err => {
        if (!err) {
          console.log(`Unsubscribed from ${topic}`);
          delete mqttSubscriptions[topic];
        }
      });
    },

    publishMQTT(topic, message) {
      if (!this.mqttClient) return;

      this.mqttClient.publish(topic, message, err => {
        if (err) console.error("Publish error:", err);
      });
    }
  }
};

export default MixinMqttClient;



// WEBPACK FOOTER //
// ./src/components/mqtt/MixinMqttClient.js